export const seoTitle = '超分辨率模拟风系统 | 产品服务 | 赑玄阁';
export const seoDescription = '超分辨率模拟风系统是基于城市复杂下垫面环境的大风三维数值模拟仿真系统通过高精度修正地理模型， 模拟复杂下垫面环境下城市强风的数值，为各类户外生产活动提供精细化强风预警服务。';
export const browserTitle = '超分辨率模拟风系统 | 产品服务 | 赑玄阁';
export const keywords = '模拟风, 天气模拟, 天气模拟软件, 模拟风系统, 超分辨率, 下垫面, 强风预警, 三维数值模拟';
